"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("D:\\\u9879\u76EE\u7BA1\u7406\\\u65E7\u6362\u65B0\\\u6E90\u7801\\yijiuhuanxin_project_java\\WebPcAdmin\\node_modules\\@babel\\runtime\\regenerator\\index.js"));

var _statistic = require("@/api/statistic");

var _newToExcel = _interopRequireDefault(require("@/utils/newToExcel.js"));

var _index2 = _interopRequireDefault(require("@/components/echartsNew/index"));

var _permission = require("@/utils/permission");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// 权限判断函数
var _default = {
  name: "userInfo",
  components: {
    echartsNew: _index2.default
  },
  data: function data() {
    return {
      spinShow: false,
      grid: {
        xl: 4,
        lg: 8,
        md: 12,
        sm: 24,
        xs: 24
      },
      userView: {},
      name: "近30天",
      fromList: this.$constants.timeList,
      dateLimit: "",
      dateLimitPram: "",
      pickerOptions: this.$timeOptions,
      timeVal: [],
      dataTime: "",
      optionData: {},
      style: {
        height: "375px"
      }
    };
  },
  created: function created() {
    var end = new Date();
    var start = new Date();
    start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 29)));
    this.timeVal = [start, end];
  },
  mounted: function mounted() {
    this.dateLimit = "lately7";
    this.dateLimitPram = "lately7";
    this.getUserView();
    this.getChannel();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    onSeach: function onSeach() {
      this.getUserView();
    },
    selectChange: function selectChange(limit) {
      if (limit == "") {
        //昨天的时间
        this.dateLimitPram = "yesterday";
        this.getUserView();
      } else {
        this.dateLimitPram = limit;
        this.getUserView();
      }
    },
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.$set(this, "dateLimitPram", e ? this.timeVal.join(",") : "");
    },
    //用户概览
    getUserView: function getUserView() {
      var _this = this;

      (0, _statistic.userOverviewData)({
        dateLimit: this.dateLimitPram
      }).then(function (res) {
        _this.userView = res;
      });
    },
    exports: function () {
      var _exports = _asyncToGenerator( /*#__PURE__*/_index.default.mark(function _callee() {
        var th, filekey, data, fileName, lebData;
        return _index.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                th = [], filekey = [], data = [], fileName = "";
                _context.next = 3;
                return this.getExcelData();

              case 3:
                lebData = _context.sent;
                //表格主要数据
                if (!fileName) fileName = "用户统计表"; //文件名

                if (!filekey.length) {
                  filekey = lebData.filekey;
                }

                if (!th.length) th = lebData.header; //表头

                data = data.concat(lebData.exportData);
                (0, _newToExcel.default)(th, filekey, fileName, data);

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exports() {
        return _exports.apply(this, arguments);
      }

      return exports;
    }(),
    getExcelData: function getExcelData(excelData) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        (0, _statistic.userOverviewListApi)({
          dateLimit: _this2.dateLimitPram
        }).then(function (res) {
          var header = ["日期/时间", "活跃用户数", "客单价", "成交用户数量", "下单用户数量", "浏览量", "成交金额", "充值用户数", "注册用户数"];
          var filekey = ["date", "activeUserNum", "customerPrice", "orderPayUserNum", "orderUserNum", "pageviews", "payOrderAmount", "rechargeUserNum", "registerNum"];
          var exportData = new Array();
          exportData = res.map(function (item) {
            return {
              date: item.date,
              activeUserNum: item.activeUserNum,
              customerPrice: item.customerPrice,
              orderPayUserNum: item.orderPayUserNum,
              orderUserNum: item.orderUserNum,
              pageviews: item.pageviews,
              payOrderAmount: item.payOrderAmount,
              rechargeUserNum: item.rechargeUserNum,
              registerNum: item.registerNum
            };
          });
          resolve({
            header: header,
            filekey: filekey,
            exportData: exportData
          });
        });
      });
    },
    //渠道
    getChannel: function getChannel() {
      var _this3 = this;

      (0, _statistic.userChannelData)().then(function (res) {
        var channelData = new Array();
        channelData = [{
          name: "H5",
          value: 0,
          channel: "h5"
        }, {
          name: "APP",
          value: 0,
          channel: "ios"
        }, {
          name: "小程序",
          value: 0,
          channel: "routine"
        }, {
          name: "公众号",
          value: 0,
          channel: "wechat"
        }];
        var channelArr = new Array();
        channelData.forEach(function (item) {
          res.forEach(function (item1) {
            //通过两层遍历返回api数据的长度，并且得到指定key的渠道name
            if (item.channel == item1.channel) {
              channelArr.push({
                name: item.name,
                value: item1.num ? item1.num : 0,
                channel: item1.channel
              });
            }
          });
        });
        _this3.optionData = {
          tooltip: {
            trigger: "item"
          },
          legend: {
            orient: "vertical",
            left: "right"
          },
          series: [{
            name: "访问来源",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              },
              normal: {
                color: function color(params) {
                  //自定义颜色
                  var colorList = ["#1BBE6B", "#1890FF", "#EF9C20", "#4BCAD5"];
                  return colorList[params.dataIndex];
                }
              }
            },
            labelLine: {
              show: false
            },
            data: channelArr
          }]
        };
      });
    }
  }
};
exports.default = _default;